var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMedicalPolicyFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 142,
  viewBox: "0 0 130 142",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/medical_policy_filled.svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 21,
  width: 48,
  height: 60,
  rx: 5,
  fill: "#005FF9",
  stroke: "#005FF9",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 55,
  width: 22,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 61,
  width: 16.9167,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 67,
  width: 11.5184,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.6534 33.1784C68.9463 31.4713 66.1734 31.4713 64.4663 33.1784L59.3466 38.298C57.6395 40.0052 57.6395 42.778 59.3466 44.4852C61.0538 46.1923 63.8266 46.1923 65.5338 44.4852L70.6534 39.3655C72.3605 37.6584 72.3605 34.8855 70.6534 33.1784ZM62.613 37.5062C62.7976 37.3215 63.0531 37.2262 63.313 37.2454C63.8363 37.3329 64.7445 37.5578 65.5093 38.3225C66.2775 39.0908 66.4954 40.0104 66.5549 40.538C66.5706 40.7892 66.4779 41.035 66.3003 41.2127C65.8689 41.6747 65 42.5444 65 42.5444L64.2965 43.2479C63.2719 44.2725 61.6085 44.2725 60.5839 43.2479C59.5593 42.2233 59.5593 40.5599 60.5839 39.5353L61.7966 38.3225C61.7966 38.3225 62.2936 37.8255 62.613 37.5062Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/medical_policy_filled.svg__filter0_d",
  x: 0,
  y: 0,
  width: 130,
  height: 142,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgMedicalPolicyFilled as ReactComponent };